@if ((corporateTaxEntity$ | async) && (vpbBerekening$ | async)) {
  <div style="max-width: 80%">

    @if ((corporateTaxEntity$ | async)?.taxType === 'DA') {
      <form [formGroup]="belastbareWinstFg">
        <div class="row">
          <div class="col col-1">
            <p>Saldo fiscale winst</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="saldoFiscaleWinst"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
        @if ((vpbBerekening$ | async)!.belastbareWinst?.vrijgesteldeWinstbestanddelen !== undefined) {
          <div class="row">
            <div class="col col-1">
              <p>Af: vrijgestelde winst</p>
            </div>
            <div class="col-2">
              <snelstart-ui-number-form-control [disabledControl]="true"
                                                [showAllDecimals]="false"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="vrijgesteldeWinstbestanddelen"
                                                prefix="€ -"
              >
              </snelstart-ui-number-form-control>
            </div>
            <div class="col-3"></div>
          </div>
        }

        @if ((corporateTaxEntity$ | async)!.aangifte?.vermogensvergelijking?.beperktAftrekbareKosten !== undefined) {
          <div class="row">
            <div class="col col-1">
              <p>Bij: beperkt aftrekbare deel gemengde kosten</p>
            </div>
            <div class="col-2">
              <snelstart-ui-number-form-control [disabledControl]="true"
                                                [showAllDecimals]="false"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="beperktAftrekbareKosten"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
            </div>
            <div class="col-3"></div>
          </div>
        }

        @if ((corporateTaxEntity$ | async)!.aangifte?.vermogensvergelijking?.nietAftrekbareBoetes !== undefined) {
          <div class="row">
            <div class="col col-1">
              <p>Bij: niet aftrekbare boetes</p>
            </div>
            <div class="col-2">
              <snelstart-ui-number-form-control [disabledControl]="true"
                                                [showAllDecimals]="false"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="nietAftrekbareBoetes"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
            </div>
            <div class="col-3"></div>
          </div>
        }

        @if ((corporateTaxEntity$ | async)!.aangifte?.vermogensvergelijking?.nietAftrekbareRente !== undefined) {
          <div class="row">
            <div class="col col-1">
              <p>Bij: niet aftrekbare rente</p>
            </div>
            <div class="col-2">
              <snelstart-ui-number-form-control [disabledControl]="true"
                                                [showAllDecimals]="false"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="nietAfrekbareRente"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
            </div>
            <div class="col-3"></div>
          </div>
        }

        @if ((vpbBerekening$ | async)!.belastbareWinst?.investeringsregelingenTotaal !== undefined) {
          <div class="row">
            <div class="col col-1">
              <p>Af: investeringsaftrek</p>
            </div>
            <div class="col-2">
              <snelstart-ui-number-form-control [disabledControl]="true"
                                                [showAllDecimals]="false"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="investeringsregelingenTotaal"
                                                prefix="€ -"
              >
              </snelstart-ui-number-form-control>
            </div>
            <div class="col-3"></div>
          </div>
        }

        <div class="row">
          <div class="col col-1">
            <p>Af: vermindering innovatiebox</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="saldoVoordeelInnovatiebox"
                                              prefix="€ -"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-3"></div>
        </div>

        <div class="row">
          <div class="col col-1">
            <p>Af: mutatie fiscale reserves</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="mutatieReserves"
                                              prefix="€ -"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-3"></div>
        </div>

        <div class="row">
          <div class="col col-1">
            <p>Af: deelnemingsvrijstelling</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="deelnemingsvrijstelling"
                                              prefix="€ -"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-3"></div>
        </div>

        <div class="row">
          <div class="col col-1">
            <p>Af: aftrekbare giften</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="aftrekbareGiften"
                                              prefix="€ -"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-3"></div>
        </div>
      </form>
    } @else {
      <form [formGroup]="belastbareWinstFg">
        <div class="row">
          <div class="col col-1">
            <p>Saldo fiscale winst</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="saldoFiscaleWinst"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>

        <div>
          <div class="row">
            <div class="col col-1">
              <p>Bij: beperkt aftrekbare deel gemengde kosten</p>
            </div>
            <div class="col-2">
              <snelstart-ui-number-form-control [disabledControl]="true"
                                                [showAllDecimals]="false"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="beperktAftrekbareKosten"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
            </div>
            <div class="col-3"></div>
          </div>
        </div>
        <div>
          <div class="row">
            <div class="col col-1">
              <p>Bij: niet aftrekbare boetes</p>
            </div>
            <div class="col-2">
              <snelstart-ui-number-form-control [disabledControl]="true"
                                                [showAllDecimals]="false"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="nietAftrekbareBoetes"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
            </div>
            <div class="col-3"></div>
          </div>
        </div>
      </form>
    }

    <form [formGroup]="tellingenFg">
      <div class="row">
        <div class="col col-1">
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [calculate]="optellenWinstCorrecties()"
                                            [disabledControl]="true"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150 custom-readonly"
                                            formControlName="tellingWinstCorrectiesAftrek"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>

    <form [formGroup]="belastbareWinstFg">
      <div class="row">
        <div class="col col-1">
          <p>Belastbare winst</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [disabledControl]="true"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="belastbareWinst"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>

    <form [formGroup]="belastbaarBedragFg">
      <div class="row">
        <div class="col col-1">
          <p>Af: verliesverrekening</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [disabledControl]="true"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="totaalTeVerrekenenVerlies"
                                            id="totaalTeVerrekenenVerlies"
                                            placeholder="0"
                                            prefix="€ -"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>

      <div class="row">
        <div class="col col-1">
          <p>Belastbaar bedrag</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [disabledControl]="true"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="belastbaarBedrag"
                                            id="belastbaarBedrag"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>

    @if (this.belastbaarBedragFg.get('belastbaarBedrag')?.getRawValue() < 0) {
      <form [formGroup]="verliesCompensatieFg">
        <div class="pt-3">
          <div class="row">
            <div class="col col-1">
              <p>Te verrekenen verlies van dit boekjaar (max.
                € {{ this.belastbaarBedragFg.get('belastbaarBedrag')?.getRawValue() * -1 | number: '1.0-0' }})
                met winst voorgaand jaar </p>
            </div>
            <div class="col-2">
              <snelstart-ui-number-form-control (change)="this.saveForm()"
                                                [showAllDecimals]="false"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="verrekeningVerliesDitBoekjaar" id="verlies"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
            </div>
          </div>
        </div>
      </form>
    }

<!--    <form [formGroup]="tellingenFg">-->
<!--      <div class="row">-->
<!--        <div class="col col-1">-->
<!--          <p>Restant verlies dit boekjaar</p>-->
<!--        </div>-->
<!--        <div class="col-2">-->
<!--          <snelstart-ui-number-form-control [disabledControl]="true"-->
<!--                                            [calculate]="updateRestantVerlies()"-->
<!--                                            [showAllDecimals]="false"-->
<!--                                            align="right"-->
<!--                                            class="custom-input-150"-->
<!--                                            formControlName="restantVerliesDitBoekjaar"-->
<!--                                            id="verlies"-->
<!--                                            prefix="€"-->
<!--          >-->
<!--          </snelstart-ui-number-form-control>-->
<!--        </div>-->
<!--      </div>-->
<!--    </form>-->
  </div>
}
